module.exports = __webpack_public_path__ + "img/54.58538f7b.jpg";